// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"6581747b","680":"739ff220"}[chunkId] + ".chunk.css";
};